module.exports = __webpack_public_path__ + "static/img/share-rule-txt.91bdbdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/result-2/share-rule-txt.png
// module id = 181
// module chunks = 0